import { AxiosResponse } from 'axios'
import { UserItemProps } from '../reducer/generalReducer'
import { MainAction } from './models'
import {
  FETCH_CALENDAR,
  FETCH_SEARCH_CALENDAR,
  FETCH_USER,
  GET_TOP_BANNER,
  GET_TRACKER_URL,
  SUBMIT_PAYMENT,
} from './types'
import { SubmitEmailProps } from '../types'
import { getClientBaseUrl } from '@/helpers/getClientBaseUrl'

export type HouseCalendarData = {
  houseId?: string
  fromDate?: string | number
  toDate?: string | number
  needMaxDays?: boolean
}

export const fetchCalendar: MainAction<[HouseCalendarData?, any?]> =
  (
    { houseId, fromDate, toDate, needMaxDays }: HouseCalendarData = {
      fromDate: '',
      toDate: '',
      houseId: '',
      needMaxDays: false,
    },
    setLoading,
  ) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    const params: {
      from_date?: string | number
      to_date?: string | number
      need_max_checkin_days?: number
    } = {}
    if (fromDate) {
      params.from_date = fromDate
    }
    if (toDate) {
      params.to_date = toDate
    }
    params.need_max_checkin_days = 1
    // dispatch({
    //   type: FETCH_CALENDAR,
    //   payload: null,
    //   loading: false
    // })
    if (setLoading) setLoading(true)
    try {
      const res: AxiosResponse = await api.get(
        `/house/${houseId || 'ct'}/calendar`,
        params,
      )

      dispatch({
        type: houseId ? FETCH_CALENDAR : FETCH_SEARCH_CALENDAR,
        payload: res?.data?.data?.records,
      })
      if (setLoading) setLoading(false)
    } catch (err) {
      dispatch({
        type: houseId ? FETCH_CALENDAR : FETCH_SEARCH_CALENDAR,
        payload: getState().calendarData,
      })
      if (setLoading) setLoading(false)
      // Handle ERR
    }
  }

// User info actions
export const fetchUser: MainAction<[string]> =
  id =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })

    if (!id) return
    try {
      dispatch({
        type: FETCH_USER,
        data: {
          host: getState().product.data.host,
        },
        loading: true,
      })
      const res: AxiosResponse<{ data: { records: UserItemProps } }> =
        await api.get(`/profile/${id}`, {
          id,
        })

      dispatch({
        type: FETCH_USER,
        data: res?.data?.data,
        loading: false,
      })

      // Handle Res
    } catch (err) {
      dispatch({
        type: FETCH_USER,
        data: {},
        loading: false,
      })
      // Handle Err
    }
  }
export const rechargeWallet: MainAction<
  [string, number, (type: 'SUCCESS' | 'ERROR', data?) => void]
> =
  (token, pgw, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({
      dispatch,
      getState,
      ctx,
    })
    try {
      // eslint-disable-next-line no-unused-vars
      const res = await api.post(
        `/payments/pay-token`,
        {
          token,
          invoice: -1,
          pgw,
        },
        {
          baseURL: getClientBaseUrl()?.split('/api/fa/sandbox/v_1_4')[0],
        },
      )

      if (res.status === 200) {
        callback('SUCCESS', res?.data?.url)
      }
    } catch (err) {
      callback('ERROR')
    }
  }

export const getTopBanner: MainAction =
  () =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: GET_TOP_BANNER,
        data: {},
        loading: true,
      })
      const res = await api.get(
        `${
          getClientBaseUrl()?.split('/api/fa/sandbox/v_1_4')[0]
        }/campaign-count-down`,
      )
      dispatch({
        type: GET_TOP_BANNER,
        data: res.data,
        loading: false,
      })
    } catch (err) {
      dispatch({
        loading: false,
        type: GET_TOP_BANNER,
        data: {},
      })
    }
  }

export const submitEmail: MainAction<[SubmitEmailProps, any]> =
  (data, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      const res = await api.post(`/user/support/message`, data)
      callback && callback('SUCCESS')
    } catch (err) {
      callback && callback('ERROR')
    }
  }

export const getTrackerUrl: MainAction<[string, any]> =
  (clientName, callback) =>
  async (dispatch, getState, { Api, ctx }) => {
    const api = new Api({ dispatch, getState, ctx })
    try {
      dispatch({
        type: GET_TRACKER_URL,
        data: {},
        loading: true,
      })
      const res = await api.get(`wallet/get-tracker-url`, {
        client: clientName,
      })
      dispatch({
        type: GET_TRACKER_URL,
        data: res.data.data,
        loading: false,
      })
    } catch (err: any) {
      dispatch({
        loading: false,
        type: GET_TRACKER_URL,
        data: {},
      })
      callback({ status: true, message: err?.response?.data?.message })
    }
  }
